import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-10 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-12">
          {/* Logo e Descrição */}
          <div className="col-span-2 md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/3dcdbb178e5fb905220d9ae2fca35ce8.png" 
              alt="Moviis Logo" 
              className="h-8 sm:h-10 brightness-0 invert mb-4"
            />
            <p className="text-gray-400 text-sm mb-5 sm:mb-6">
              {t('footer_description')}
            </p>
            <div className="flex gap-3 sm:gap-4">
              <a
                href="https://www.linkedin.com/company/moviis/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/moviis__/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://wa.me/551132552877"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Produtos */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">{t('footer_products')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#produtos" className="text-gray-400 hover:text-orange-500 transition-colors text-xs sm:text-sm cursor-pointer">
                  {t('footer_product1')}
                </a>
              </li>
              <li>
                <a href="#produtos" className="text-gray-400 hover:text-orange-500 transition-colors text-xs sm:text-sm cursor-pointer">
                  {t('footer_product2')}
                </a>
              </li>
              <li>
                <a href="#produtos" className="text-gray-400 hover:text-orange-500 transition-colors text-xs sm:text-sm cursor-pointer">
                  {t('footer_products')}
                </a>
              </li>
            </ul>
          </div>

          {/* Informações */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">{t('footer_info')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#produtos" className="text-gray-400 hover:text-orange-500 transition-colors text-xs sm:text-sm cursor-pointer">
                  {t('footer_about')}
                </a>
              </li>
              <li>
                <a href="#contato" className="text-gray-400 hover:text-orange-500 transition-colors text-xs sm:text-sm cursor-pointer">
                  {t('footer_warranty')}
                </a>
              </li>
              <li>
                <a href="#contato" className="text-gray-400 hover:text-orange-500 transition-colors text-xs sm:text-sm cursor-pointer">
                  {t('footer_delivery')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div className="col-span-2 md:col-span-1">
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">{t('footer_contact')}</h4>
            <ul className="space-y-3 text-xs sm:text-sm text-gray-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-orange-500 mt-1 shrink-0"></i>
                <span>
                  {t('footer_address')}<br />
                  {t('footer_building')}
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-orange-500 shrink-0"></i>
                <a href="tel:+551132552877" className="hover:text-orange-500 transition-colors cursor-pointer">
                  (11) 3255-2877
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-orange-500 shrink-0"></i>
                <a href="mailto:comercial@moviis.com.br" className="hover:text-orange-500 transition-colors cursor-pointer break-all">
                  comercial@moviis.com.br
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-orange-500 mt-1 shrink-0"></i>
                <span>
                  {t('footer_hours')}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8 text-center">
          <p className="text-gray-400 text-xs sm:text-sm">
            {t('footer_rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}